import React from "react";

const formatDate = (d) => {
  if (!d) return "-";
  const date = new Date(d);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("ar-SA");
};

const roleLabel = (role) => {
  if (role === "user") return "عميل";
  if (role === "contractor") return "مقاول";
  if (role === "supplier") return "مورد";
  return role;
};

const typeLabel = (type) => (type === "yearly" ? "سنوي" : "شهري");

const statusBadge = (sub) => {
  const now = Date.now();
  const accessible =
    sub.status === "active" &&
    new Date(sub.startDate).getTime() <= now &&
    now < new Date(sub.endDate).getTime();
  if (accessible && Number(sub.price) === 0)
    return { label: "تجربة مجانية", className: "bg-blue-500 text-white" };
  if (accessible) return { label: "نشط", className: "bg-green-500 text-white" };
  return { label: "منتهي", className: "bg-gray-400 text-white" };
};

const SubscribersColumn = () => [
  {
    Header: "تحديد",
    id: "checkbox",
  },
  {
    Header: "الاسم",
    accessor: "user.name",
    Cell: ({ row }) => row.original.user?.name || "-",
  },
  {
    Header: "رقم الهاتف",
    accessor: "user.phoneNumber",
    Cell: ({ row }) => row.original.user?.phoneNumber || "-",
  },
  {
    Header: "الدور",
    accessor: "role",
    Cell: ({ row }) => roleLabel(row.original.role),
  },
  {
    Header: "النوع",
    accessor: "type",
    Cell: ({ row }) => typeLabel(row.original.type),
  },
  {
    Header: "السعر",
    accessor: "price",
    Cell: ({ row }) => `${row.original.price} ر.س`,
  },
  {
    Header: "البداية",
    accessor: "startDate",
    Cell: ({ row }) => formatDate(row.original.startDate),
  },
  {
    Header: "الانتهاء",
    accessor: "endDate",
    Cell: ({ row }) => formatDate(row.original.endDate),
  },
  {
    Header: "الحالة",
    accessor: "status",
    Cell: ({ row }) => {
      const badge = statusBadge(row.original);
      return (
        <span className={`rounded-full px-2 py-1 text-xs ${badge.className}`}>
          {badge.label}
        </span>
      );
    },
  },
];

export default SubscribersColumn;
